import { useContext } from "react";
import { GptContext } from "./ChatbotContainer";
import Typewriter from "typewriter-effect";
import { FaCircleNotch } from "react-icons/fa";

const MessageLoading = () => {
    const { loading } = useContext(GptContext);

    return (
        <>
            <div id="loading">
                {loading ? (
                    <>
                        <FaCircleNotch
                            icon="fa-circle-notch"
                            className="spinner"
                        />
                        <Typewriter
                            onInit={(typewriter) => {
                                typewriter
                                    .typeString(
                                        "loading... (it may take up to 20 seconds)"
                                    )
                                    .pauseFor(20000)
                                    .deleteAll(1)
                                    .typeString(
                                        "still loading... (taking longer than usual)"
                                    )
                                    .pauseFor(10000)
                                    .deleteAll(1)
                                    .typeString(
                                        "taking too long ... (you may want to return later)"
                                    )
                                    .start();
                            }}
                            options={{
                                delay: 0
                                // cursor: "."
                            }}
                        />
                    </>
                ) : null}
            </div>
        </>
    );
};

export default MessageLoading;
